import { render } from "./AptGlossaryView.vue?vue&type=template&id=092f11bd&ts=true"
import script from "./AptGlossaryView.vue?vue&type=script&lang=ts"
export * from "./AptGlossaryView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__